export default (state, action) => {
  return Object.assign({}, state, {
    data: Object.assign({}, state.data, {
      cartToken: action.token,
      loading: true,
    }),
  });
};
